import {
    FETCH_MATERIALS_LIST_REQUEST,
    FETCH_MATERIALS_LIST_SUCCESS,
    FETCH_MATERIALS_LIST_FAILURE,
  } from "./FetchMaterialsListTypes";
  import api from "../../utils/Api";
  import axios from 'axios';
  
  export const fetchMaterialsListRequest = () => {
    return {
      type: FETCH_MATERIALS_LIST_REQUEST,
    };
  };
  
  export const fetchMaterialsListSuccess = (materialsList) => {
    return {
      type: FETCH_MATERIALS_LIST_SUCCESS,
      payload: materialsList,
    };
  };
  
  export const fetchMaterialsListFailure = (error) => {
    return {
      type: FETCH_MATERIALS_LIST_FAILURE,
      payload: error,
    };
  };
  
  const CancelToken = axios.CancelToken;
    let cancelRequest;
  export const fetchMaterialsList = (page, payload) => {
    //cancel previous request if multiple hits done.
    cancelRequest && cancelRequest();
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "medprax/material/list/fetch?pageSize=5&page=" + page;

    if(payload && payload.search_filter && payload.search_key){
      url += "&"+ payload.search_filter+ "=" + payload.search_key;
    }
    return async (dispatch) => {
      dispatch(fetchMaterialsListRequest);
      try {
        const response = await api.get(
          url,
          {
            headers: headers,
            cancelToken: new CancelToken(function executor(c) {
              cancelRequest = c;
          })
          }
        );
  
        const materialsList = response.data.data;
        dispatch(fetchMaterialsListSuccess(materialsList));
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Error: ', error.message); // => prints: Api is being canceled
        } 
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchMaterialsListFailure(errorMsg));
      }
    };
  };
  